import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export const useDealsPageAnalytics = () => {
  const { pathname } = useLocation();
  const { setAdobePageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.deals) {
      const adobeAnalyticsObj = {
        eventinfo: { eventtype: "other" },
      };
      setAdobePageData(adobeAnalyticsObj, "dealsPage");
    }
  }, [pathname]);
};
